// removed by extract-text-webpack-plugin
module.exports = {"view":"style__view___19bCX","title":"style__title___3jFnd","subtitle":"style__subtitle___3rPV_","tabsSpace":"style__tabsSpace___jXmrk"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-lead/style.css
// module id = 1460
// module chunks = 0